import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=318619d9&scoped=true&"
var script = {}
import style0 from "./GDPR.vue?vue&type=style&index=0&id=318619d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318619d9",
  null
  
)

export default component.exports